<template>
  <!-- <div id="app"> -->
     <!-- 路由匹配到的显示在这 -->
    <!-- <keep-alive>
    <router-view></router-view>
    </keep-alive> -->
    <div id="app">
      <router-view  />
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  height: 100vh;
}
.poppover {
  padding: 0px!important;
  min-width: auto!important;
}
.el-input__inner:focus {
  border: 1px solid #009b43!important;
}
.el-input__inner:focus .el-input__prefix {
  color: red!important;
}
/deep/.el-icon-search:before {
  color: red!important;
}
.ok_Edit:hover{
   border-radius: 3px;
  background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673)!important;
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75)!important;
   background-position: 100% 0!important;
    -o-transition: all .4s ease-in-out!important;
    -webkit-transition: all .4s ease-in-out!important;
    transition: all .4s ease-in-out!important;
}
.login_Edit:hover {
  cursor: pointer!important;
  width: 120px!important;
  height: 40px!important;
  font-size: 14px!important;
  font-weight: 500!important;
  background: #EEEEEE!important;
  border-radius: 4px!important;
  border: none!important;
  color: #999999!important;
}
.el-date-table td.today span {
  color: #009b43!important;
}
.el-date-table td.start-date span {
  background: #009b43!important;
  color: #fff!important;
}
.el-date-table td.end-date span {
  background: #009b43!important;
  color: #fff!important;
}
.el-date-table td.in-range div:hover {
  color: #009b43!important;
}
.el-date-table td:hover {
  color: #009b43!important;
}
.el-range-editor.is-active {
  border-color: #009b43!important;
}
.el-date-table td.current:not(.disabled) span {
  background: #009b43!important;
}
.el-textarea__inner:focus {
  border-color: #009b43!important;
}
.el-switch.is-checked .el-switch__core {
  background-color: #009b43!important;
  border-color: #009b43!important;
}
.el-switch__label.is-active {
  color: #009b43!important;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #009b43!important;
}
.el-dialog__headerbtn:focus{
  color: #009b43!important;
}
.el-dialog__headerbtn:focus .el-dialog__close {
  color: #009b43!important;
}
.el-dialog__headerbtn:hover .el-dialog__close {
  color: #009b43!important;
}
.el-message-box__btns button:nth-child(2) {
   cursor: pointer;
  width: 120px;
  height: 40px;
  background: #009B43;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  margin-left: 30px;
  color: #fff;
}
.el-message-box__btns button:nth-child(1) {
  cursor: pointer;
  width: 120px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  background: #EEEEEE;
  border-radius: 4px;
  border: none;
  color: #999999;
}
.el-message-box__btns button:nth-child(2):hover{
  border-radius: 3px;
  background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673)!important;
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75)!important;
   background-position: 100% 0!important;
    -o-transition: all .4s ease-in-out!important;
    -webkit-transition: all .4s ease-in-out!important;
    transition: all .4s ease-in-out!important;
}
.el-message-box__btns button:nth-child(1):hover{
   cursor: pointer!important;
  width: 120px!important;
  height: 40px!important;
  font-size: 14px!important;
  font-weight: 500!important;
  background: #EEEEEE!important;
  border-radius: 4px!important;
  border: none!important;
  color: #999999!important;
}
.el-cascader .el-input.is-focus .el-input__inner {
  border-color: #009B43!important;
}
.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
  color: #009B43!important;
}
.el-radio__input.is-checked .el-radio__inner {
  background-color: #009B43!important;
  border-color: #009B43!important;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #009B43!important;
  border-color: #009B43!important;
}
.el-select-dropdown__item.selected {
  color: #009B43!important;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #009B43!important;
}
.el-date-picker__header-label.active, .el-date-picker__header-label:hover {
  color: #009B43!important;
}
.el-picker-panel__icon-btn:hover {
  color: #009B43!important;
}
.el-year-table td.today .cell {
  color: #009B43!important;
}
.el-year-table td .cell:hover, .el-year-table td.current:not(.disabled) .cell {
  color: #009B43!important;
}
.el-month-table td .cell:hover {
  color: #009B43!important;
}
.cascader-menu-list .cascader-menu-option.selected {
  color: #009B43!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue